





























import {Component, Vue, Prop} from 'vue-property-decorator';
import Building from '@/data/models/building';
import Button from '@/components/commons/Button.vue';

@Component({components: {Button}})
export default class BuildingCard extends Vue {
  @Prop({required: true})
  building: Building;

  @Prop({required: true})
  redirect;

  handleSee(): void {
    this.$store.commit('setBreadCrumbBuilding', ` | ${this.building.name}`);
    this.$router.push({name: 'listMeters', params: {buildingId: this.building.id}});
  }

  handleSeeDashboard(): void {
    this.$router.push(`/home/${this.building.id}`);
  }
}
